import { http } from "./http";

export interface BankCodes {
    CODE: string;
    NAME: string;
    VOEN: string;
    CORR_ACCOUNT: string;
    SW_BIC: string;
    CORR_ACC_SUB: string;
};

export interface BicCodes {
    BANK_NAME: string;
    MAIN_BIC: string;
    BIC_CODE: string;
    COUNTRY: string;
    COUNTRY_ISO3: string;
};

export interface TeskilatCodes {
    code: string;
    name: string;
    orgcode: string;
    taxId: string;
};

export interface LevelCodes {
    code: string;
    name: string;
};

export interface ClassificationCodes {
    code: string;
    name: string;
};

export interface CustomerTypes {
    code: string;
    name: string;
};

export interface MtCountries {
    CODE: string;
    NAME: string;
};

export interface OrganizationCodes {
    code: string;
    orgcode: string;
    name: string;
};

export interface PaymentTypes {
    CODE: string;
    NAME: string;
};

export interface PaymentSubjects {
    CODE: string;
    NAME: string;
};

export interface TransferTypes {
    CODE: string;
    NAME: string;
};

export interface TransferSubTypes {
    CODE: string;
    NAME: string;
};

export interface Branches {
    branch_id: string;
    branch_name: string;
};



/*   */
export const getBankCodes = async (): Promise<BankCodes[]> => {
    const { data } = await http.get<BankCodes[]>(`moneytransfer/moneytransfer/bankcodes`);
    return data;
};

export const getBicCodes = async (bic_codes : string): Promise<BicCodes[]> => {
    const { data } = await http.get<BicCodes[]>(`bank/biccodesrus?filter=${bic_codes}`);
    return data;
};

export const getBicCodesByCountryName = async (country : string='', bankname : string =''): Promise<BicCodes[]> => {

    let query_param='';

    if (country){
        query_param+=`?country=${country}`;
    }

    if (bankname){
        query_param+=query_param==='' ? '?' : '&';

        query_param+=`bankname=${bankname}`

    }

    const { data } = await http.get<BicCodes[]>(`bank/biccodes${query_param}`);
    return data;
};

export const getBicCodesByFilter = async (filter : string='', iso3 : string =''): Promise<BicCodes[]> => {

    let query_param='';

    if (filter){
        query_param+=`?filter=${filter}`;
    }

    if (iso3){
        query_param+=query_param==='' ? '?' : '&';

        query_param+=`iso3=${iso3}`

    }

    const { data } = await http.get<BicCodes[]>(`bank/biccodes${query_param}`);
    return data;
};

export const getTeskilatCodesByFilter = async (orgcode: string = '', name: string = '', taxid: string = ''): Promise<TeskilatCodes[]> => {
    const body = { ...(orgcode ? { orgcode } : {}), ...(name ? { name } : {}), ...(taxid ? { taxid } : {}) };
    const { data } = await http.post<any>(`moneytransfer/teskilatcodes`, body);
    return data;
};


export const getLevelCodes = async (): Promise<LevelCodes[]> => {
    const { data } = await http.get<LevelCodes[]>(`moneytransfer/moneytransfer/btlevels`);
    return data;
};

export const getClassificationCodes = async (): Promise<ClassificationCodes[]> => {
    const { data } = await http.get<ClassificationCodes[]>(`moneytransfer/moneytransfer/btclass`);
    return data;
};

export const getCustomerTypes = async (): Promise<CustomerTypes[]> => {
    const { data } = await http.get<CustomerTypes[]>(`bank/customertypes`);
    return data;
};

export const getMtCountries = async (): Promise<MtCountries[]> => {
    const { data } = await http.get<MtCountries[]>(`moneytransfer/moneytransfer/mtcountries`);
    return data;
};

export const getOrganizationCodes = async (): Promise<OrganizationCodes[]> => {
    const { data } = await http.get<OrganizationCodes[]>(`moneytransfer/moneytransfer/btorgs`);
    return data;
};

export const getPaymentTypes = async (): Promise<PaymentTypes[]> => {
    const { data } = await http.get<PaymentTypes[]>(`moneytransfer/moneytransfer/paymenttype`);
    return data;
};

export const getPaymentSubjects = async (): Promise<PaymentSubjects[]> => {
    const { data } = await http.get<PaymentSubjects[]>(`moneytransfer/moneytransfer/paymentsubject`);
    return data;
};

export const getTransferTypes = async (): Promise<TransferTypes[]> => {
    const { data } = await http.get<TransferTypes[]>(`moneytransfer/moneytransfer/mttype`);
    return data;
};

export const getTransferSubTypes = async (transfer_type : TransferTypes): Promise<TransferSubTypes[]> => {
    const { data } = await http.get<TransferSubTypes[]>(`moneytransfer/moneytransfer/mttype?mttype=${transfer_type.CODE}`);
    return data;
};

export const getBranches = async (): Promise<Branches[]> => {
    const { data } = await http.get<Branches[]>(`bank/branch`);
    return data;
};
